function locatorIsPendingReset(locator) {
  return locator.data.events?.resetRequestState === 'sent' || locator.data.events?.resetRequestState === 'pending';
}
function locatorMeetsFirmwareRequirements(locator) {
  const version = locator.data.firmware?.reportedMcuVersion?.split('.');

  // remote reset support starts with MCU v01.03.02

  if (version?.[0] > '01') {
    return true;
  }
  if (version?.[0] === '01') {
    if (version?.[1] > '03') {
      return true;
    }
    if (version?.[1] === '03') {
      if (version?.[2] >= '02') {
        return true;
      }
      return false;
    }
    return false;
  }
  return false;
}
export default {
  locatorIsPendingReset,
  locatorMeetsFirmwareRequirements
};